import { render, staticRenderFns } from "./xiugaijiaoben.vue?vue&type=template&id=0107a7ad&scoped=true"
import script from "./xiugaijiaoben.vue?vue&type=script&lang=js"
export * from "./xiugaijiaoben.vue?vue&type=script&lang=js"
import style0 from "./xiugaijiaoben.vue?vue&type=style&index=0&id=0107a7ad&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0107a7ad",
  null
  
)

export default component.exports